module.exports = __webpack_public_path__ + "img/lxq.7484341a.jpg";